<div *ngIf="currentStep === 1">
  <ng-container
    *ngIf="tenderType === 'consultancy services'; else constructionWork"
  >
    <app-consultancy-services
      [tendererResponseData]="tendererResponseData"
      (consultancyServiceDataEmitter)="
        handleConsultancyServiceEmittedData($event)
      "
      (closeModalEvent)="handleCloseModal()"

    ></app-consultancy-services>
  </ng-container>

  <ng-template #constructionWork>
    <app-construction-work
      [tendererResponseData]="tendererResponseData"
      (constructionWorksDataEmitter)="
        handleConstructionWorksEmittedData($event)
      "
      (closeModalEvent)="handleCloseModal()"
    ></app-construction-work>
  </ng-template>
</div>

<div *ngIf="currentStep === 2 && submissionType === 'technical'">
  <app-technical-submission
    [tendererResponseData]="tendererResponseData"
    (technicalSubmissionDataEmitter)="
      handleTechnicalSubmissionEmittedData($event)
    "
    (closeModalEvent)="handleCloseModal()"
  ></app-technical-submission>
</div>

<div *ngIf="currentStep === 2 && submissionType === 'commercial'">
  <app-commercial-submission
    [tendererResponseData]="tendererResponseData"
    (commercialSubmissionDataEmitter)="
      handleCommercialSubmissionEmittedData($event)
    "
    (closeModalEvent)="handleCloseModal()"
  ></app-commercial-submission>
</div>

<div *ngIf="currentStep === 3">
  <app-conclusion
    [tendererResponseData]="tendererResponseData"
    (closeModalEvent)="handleCloseModal()"
  >
  </app-conclusion>
</div>
